'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.exists = exists;
exports.hasKey = hasKey;
exports.secureUrl = secureUrl;
exports.secureImagesInData = secureImagesInData;
exports.toRelativeUrl = toRelativeUrl;
exports.getBackgroundImage = getBackgroundImage;
exports.getCurrentProtocol = getCurrentProtocol;
exports.decodeHex = decodeHex;
exports.encodeHex = encodeHex;
exports.getCookie = getCookie;
exports.isInArray = isInArray;
exports.getTwitterHandle = getTwitterHandle;

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Helper function to determine if a given property exists
 * @param {Object} property Property being tested
 * @returns {boolean}
 */
function exists(property) {
  if (typeof property !== 'undefined' && property) {
    return true;
  }
  return false;
}

/**
 * Helper function to check if key is not null and defined
 * @param {Object} obj to te tested
 * @param {string} key to be checked
 * @returns {boolean}
 */
function hasKey(obj, key) {
  var tempObj = obj;
  return key.split('.').every(function (x) {
    if ((typeof tempObj === 'undefined' ? 'undefined' : (0, _typeof3.default)(tempObj)) !== 'object' || tempObj === null || !(x in tempObj) || !tempObj[x]) {
      return false;
    }
    tempObj = tempObj[x];
    return true;
  });
}

/**
 * Changes url protocol from http to https
 * @param {string } url Url to be changed from http to https
 * @returns {string} https url
 */
function secureUrl(url) {
  if (exists(url)) {
    if (url.indexOf('https://') >= 0) {
      return url;
    }
    return url.replace(new RegExp('http://', 'g'), 'https://');
  }
  return null;
}

/**
 * Changes protocol on urls to https
 * @param {Object} pagePayload JSON object with api data
 * @returns {Object} pagePayload with https urls
 */
function secureImagesInData(pagePayload) {
  if (exists(pagePayload)) {
    var pageString = (0, _stringify2.default)(pagePayload);
    pageString = pageString.replace(new RegExp('http://', 'g'), 'https://');
    return JSON.parse(pageString);
  }
  return null;
}

/**
 * Converts an absolute URL to a relative one
 * @param {string} absoluteUrl Url to be converted
 * @returns {string}
 */
function toRelativeUrl(absoluteUrl) {
  if (exists(absoluteUrl)) {
    /* eslint-disable no-useless-escape */
    return absoluteUrl.replace(/^.*\/\/[^\/]+/, '');
  }
  return null;
}

/**
 * Get the background image for a slide
 * @param {Object} props the props to check for the image url
 * @param {string} key the key to search for
 * @returns {Object}
 */
function getBackgroundImage(props, key) {
  if (hasKey(props, key)) {
    return {
      backgroundImage: 'url(' + (0, _lodash2.default)(props, key) + ')'
    };
  }

  return {};
}

/**
 * Calls window.location.protocol and returns its value
 * @returns {string} the current web protocol
 */
function getCurrentProtocol() {
  return window.location.protocol;
}

/**
 * Decodes a given base16-encoded string
 * @param {string} hexEncoded base16-encoded string
 * @returns {string}
 */
function decodeHex(hexEncoded) {
  var decoded = '';
  for (var i = 0; i < hexEncoded.length; i += 2) {
    decoded += String.fromCharCode(parseInt(hexEncoded.substr(i, 2), 16));
  }
  return decodeURIComponent(decoded);
}
/**
 * Encodes a given string to base16
 * @param {string} string to encode
 * @returns {string} base16-encoded string
 */
function encodeHex(string) {
  var toEncode = encodeURIComponent(string);
  var encoded = '';
  for (var i = 0; i < toEncode.length; i += 1) {
    encoded += toEncode.charCodeAt(i).toString(16);
  }
  return encoded;
}
/**
 * Returns a cookie by name from document.cookie
 * @param {string} name cookie name
 * @returns {string}
 */
function getCookie(name) {
  var cookies = '; ' + document.cookie;
  var parts = cookies.split('; ' + name + '=');
  var cookie = '';
  if (parts.length === 2) {
    cookie = parts.pop().split(';').shift();
  }
  return cookie;
}
/**
 * Tests if an element is present in a given array
 * @param {Object} element to search in the array
 * @param {array} array of elements
 * @returns {boolean} true if the element is in the array
 */
function isInArray(element, array) {
  return exists(array) && array.indexOf(element) >= 0;
}

/**
 * Gets twitter handle from twitter URL
 * @param {string} twitterUrl Url to be converted
 * @returns {string}
 */
function getTwitterHandle(twitterUrl) {
  if (exists(twitterUrl)) {
    return twitterUrl.substr(twitterUrl.lastIndexOf('/') + 1);
  }
  return null;
}


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/utils/helpers/index.js
// module id = 47
// module chunks = 35783957827783